import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { FiltersModule } from '@pwc-bei/forms';
import { I18nModule } from '@pwc-bei/i18n';
import { PwcIconsModule } from '@pwc-bei/icons';
import { UIModule } from '@pwc-bei/ui';
import { NgxCurrencyDirective } from 'ngx-currency';
import { ActionModule } from 'src/app/components/action-menu/action.module';
import { AtecoModule } from 'src/app/components/ateco/ateco.module';
import { LabelModule } from 'src/app/components/label/label.module';
import { UploadsModule } from '../uploads/uploads.module';
import { IncentiveFaqListComponent } from './faq/components/incentiveFaq-list.component';
import { IncentiviRoutingModule } from './incentivi-routing.module';
import { BaseStep } from './project/models/base-step';
import { UpgradePlanFormComponent } from './tax-break/components/upgrade-plan/upgrade-plan-form/upgrade-plan-form.component';

@NgModule({
  declarations: [IncentiveFaqListComponent, BaseStep, UpgradePlanFormComponent],
  imports: [
    CommonModule,
    IncentiviRoutingModule,
    I18nModule,
    TranslateModule.forChild(),
    UIModule,
    PwcIconsModule,
    FormsModule,
    LabelModule,
    NgSelectModule,
    NgxCurrencyDirective,
    UploadsModule,
    ActionModule,
    FiltersModule,
    AtecoModule,
  ],
  exports: [TranslateModule],
})
export class IncentiviModule {}
